// Version info for debugging deployment issues
export const APP_VERSION = '2.0.0';
export const BUILD_DATE = '2026-01-31T00:45:00Z';
export const BUILD_ID = 'b20260131-capacitaciones';
